import * as Yup from "yup";

const form = {
  formId: "update-user-info-form",
  formField: {
    user_firstname: {
      name: "user_firstname",
      label: "First Name",
      type: "text",
      errorMsg: "First Name is required.",
    },
    user_lastname: {
      name: "user_lastname",
      label: "Last Name",
      type: "text",
      errorMsg: "Last Name is required.",
    },
    user_email: {
      name: "user_email",
      label: "Email",
      type: "email",
      errorMsg: "Email is required.",
      invalidMsg: "Email is not valid.",
    },
    user_confirmationEmail: {
      name: "user_confirmationEmail",
      label: "Confirmation Email",
      type: "email",
      errorMsg: "Confirmation Email is required.",
      invalidMsg: "Confirmation Email is not valid.",
    },
  },
};

const {
  formField: { user_firstname, user_lastname, user_email, user_confirmationEmail },
} = form;

const initialValues = {
  [user_firstname.name]: "",
  [user_lastname.name]: "",
  [user_email.name]: "",
  [user_confirmationEmail.name]: "",
};

const validations = Yup.object().shape({
  [user_firstname.name]: Yup.string().required(user_firstname.errorMsg),
  [user_lastname.name]: Yup.string().required(user_lastname.errorMsg),
  [user_email.name]: Yup.string().required(user_email.errorMsg).email(user_email.invalidMsg),
  [user_confirmationEmail.name]: Yup.string()
    .required(user_confirmationEmail.errorMsg)
    .email(user_confirmationEmail.invalidMsg)
    .oneOf([Yup.ref(user_email.name)], "Emails must match"),
});

export { form, initialValues, validations };
